module.exports = __webpack_public_path__ + "static/media/logo_showin.a1bd27e5.png";